import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import DemoSection from '../../components/DemoSection.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosCheckboxDemo',
    setup(__props) {
        const checkbox1 = ref(false);
        const checkbox2 = ref(false);
        const selectedOptions = ref(['A']);
        return { __sfc: true, checkbox1, checkbox2, selectedOptions, VContainer, VRow, VCol, CodePreview, DemoSection };
    }
});
